module.exports = __webpack_public_path__ + "img/0_en.14c3c73b.png";